document.addEventListener('DOMContentLoaded', function() {
    var BLAZE_SDK_RETRY_MAX = 60;
    var BLAZE_INIT_RETRY_MAX = 40;
    var BLAZE_SDK_RETRY_MS = 200;

    function initializeBlazeStories() {
        if (typeof BlazeSDK === 'undefined') {
            if (window._blazeSdkRetryCount === undefined) window._blazeSdkRetryCount = 0;
            if (window._blazeSdkRetryCount < BLAZE_SDK_RETRY_MAX) {
                window._blazeSdkRetryCount++;
                setTimeout(initializeBlazeStories, BLAZE_SDK_RETRY_MS);
            }
            return;
        }

        if (window.__SP_BLAZE_STORIES_READY__) {
            return;
        }

        const wscKey = window.blazeStoriesData?.wscKey;
        if (!wscKey) {
            return;
        }
        if (window.__SP_BLAZE_INIT_INFLIGHT__) {
            return;
        }
        window.__SP_BLAZE_INIT_INFLIGHT__ = true;

        // Cache commonly used values
        const styles = getComputedStyle(document.documentElement);
        const primaryFont = "'URC Sans', sans-serif";
        const secondaryFont = "'Red Hat Display', sans-serif";
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const themeCache = new Map();
        // Simplified theme getter
        const getTheme = themeName => themeCache.get(themeName) || themeCache.set(themeName, BlazeSDK.Theme(themeName) || { layoutStyle: {} }).get(themeName);

        // Theme configurations
        const baseThemeConfig = {
            labelStyle: {
                //color: '#fff',
                fontWeight: 'normal',
                fontSize: isMobile ? '14px' : '16px'
            }
        };
        // Row Circle Theme
        const rowCircleTheme = getTheme('row-circle');
        Object.assign(rowCircleTheme.layoutStyle.labelStyle = rowCircleTheme.layoutStyle.labelStyle || {}, {
            ...baseThemeConfig.labelStyle,
            gap: 10,
            fontWeight: '500',
            font: secondaryFont,
            fontFamily: 'Red Hat Display',
            fontSize: isMobile ? '12px' : '15px',
            backgroundColor: 'transparent',
            width: '72px',
            borderRadius: '8px 0',
            color: 'var(--white)',
        });

        Object.assign(rowCircleTheme.layoutStyle.circleStyle = rowCircleTheme.layoutStyle.circleStyle || {}, {
            borderWidth: 2,
            size: 110
        });

        Object.assign(rowCircleTheme.layoutStyle, {
            gap: '10px',
            padding: '5px 2px'
        });

        // Row Rectangle Theme
        const rowRectangleTheme = getTheme('row-rectangle');
        Object.assign(rowRectangleTheme.layoutStyle.labelStyle = rowRectangleTheme.layoutStyle.labelStyle || {}, {
            ...baseThemeConfig.labelStyle,
            isVisible: true,
            font: primaryFont,
            fontFamily: 'URC Sans'
        });

        Object.assign(rowRectangleTheme.layoutStyle.statusUnreadStyle, {
            backgroundColor: '#00cde6',
            borderRadius: '8px 0px'
        });

        // Row Rectangle Secondary Theme - Clone from rectangle theme
        const rowRectangleSecondaryTheme = JSON.parse(JSON.stringify(rowRectangleTheme));

        // Match Highlight Theme
        const matchHighlightTheme = getTheme('match-highlight');
        Object.assign(matchHighlightTheme.layoutStyle, {
            backgroundColor: 'transparent',
            padding: '0',
            borderRadius: '0',
            boxShadow: 'none',
            borderWidth: '0',
            borderColor: 'transparent',
            borderStyle: 'none',
            position: 'absolute',
            display: 'grid',
            alignContent: 'flex-start',
            zIndex: '-1'
        });

        Object.assign(matchHighlightTheme.layoutStyle.labelStyle = matchHighlightTheme.layoutStyle.labelStyle || {}, {
            isVisible: false,
            color: '#fff',
            fontSize: '14px',
            padding: '0px',
            backgroundColor: 'transparent',
            borderRadius: '0'
        });

        Object.assign(matchHighlightTheme.layoutStyle.imageStyle = matchHighlightTheme.layoutStyle.imageStyle || {}, {
            borderRadius: '0',
            aspectRatio: '16x9',
            width: '100%',
            objectFit: 'cover',
            background: 'transparent',
            border: 'none',
            borderWidth: '0',
            borderColor: 'transparent',
            zIndex: -1
        });

        const themeMap = {
            circle: rowCircleTheme,
            rectangle: rowRectangleTheme,
            'rectangle-secondary': rowRectangleSecondaryTheme
        };

        const wscTags = window.blazeStoriesData?.wscTags || {};

        try {
            BlazeSDK.Initialize(wscKey, { geoLocation: '' });
            window.__SP_BLAZE_STORIES_READY__ = true;
        } catch (error) {
            delete window.__SP_BLAZE_INIT_INFLIGHT__;
            return;
        }

        // Optimized scroll arrows setup
        function setupScrollArrows(containerId) {
            const storyContainer = document.querySelector(`#${containerId}`);
            if (!storyContainer) return;

            const trackContainer = storyContainer.closest('.stories-track-container');
            if (!trackContainer) return;

            const arrows = {
                left: trackContainer.querySelector('.scroll-arrow.left'),
                right: trackContainer.querySelector('.scroll-arrow.right')
            };
            const widgetLayout = storyContainer.querySelector('blaze-widget-layout');

            if (!arrows.left || !arrows.right || !widgetLayout) return;

            const updateArrowStates = () => {
                const scrollLeft = widgetLayout.scrollLeft;
                const maxScroll = widgetLayout.scrollWidth - widgetLayout.clientWidth;
                arrows.left.style.display = scrollLeft <= 0 ? 'none' : 'flex';
                arrows.right.style.display = scrollLeft >= maxScroll - 1 ? 'none' : 'flex';
            };

            const handleArrowClick = (direction) => (e) => {
                e.preventDefault();
                e.stopPropagation();
                widgetLayout.scrollBy({ left: direction * 200, behavior: 'smooth' });
            };

            // Replace arrows to remove old listeners
            Object.entries(arrows).forEach(([direction, arrow]) => {
                const newArrow = arrow.cloneNode(true);
                arrow.parentNode.replaceChild(newArrow, arrow);
                arrows[direction] = newArrow;
                newArrow.addEventListener('click', handleArrowClick(direction === 'left' ? -1 : 1));
            });

            widgetLayout.addEventListener('scroll', updateArrowStates);
            window.addEventListener('resize', updateArrowStates);
            setTimeout(updateArrowStates, 100);
        }

        // Common widget configuration
        const commonWidgetConfig = {
            contentType: 'story',
            aspectRatio: '16x9'
        };

        // Add fallback mechanism for WordPress admin authentication issues
        let connectionTimeout;
        let fallbackAttempted = false;
        
        const processWidgets = () => {
            // Process regular widgets
            Object.entries(wscTags).forEach(([containerId, tagData]) => {
                const container = document.querySelector(`#${containerId}`);
                if (!container || !themeMap[tagData.themeType]) return;

                try {
                    BlazeSDK.WidgetGridView(container.id, {
                        ...commonWidgetConfig,
                        labels: BlazeSDK.LabelBuilder().singleLabel(tagData.tag_label),
                        theme: themeMap[tagData.themeType],
                        delegates: {
                            [BlazeSDK.Delegations.onWidgetDataLoadCompleted]: e => {
                                container.style.display = e.detail.contentCount === 0 ? 'none' : 'block';
                                const widgetLayout = container.querySelector('blaze-widget-layout');
                                if (widgetLayout) {
                                    Object.assign(widgetLayout.style, {
                                        gap: '12px',
                                        overflow: 'auto hidden'
                                    });

                                    // Make scrollable stories track keyboard-focusable and named
                                    if (!widgetLayout.hasAttribute('tabindex')) {
                                        widgetLayout.setAttribute('tabindex', '0');
                                    }

                                    if (!widgetLayout.hasAttribute('aria-label') && !widgetLayout.hasAttribute('aria-labelledby')) {
                                        const sectionTitle = container.closest('.module')?.querySelector('.stories-title h2');
                                        if (sectionTitle && sectionTitle.id === '') {
                                            sectionTitle.id = `${containerId}-title`;
                                        }

                                        if (sectionTitle && sectionTitle.id) {
                                            widgetLayout.setAttribute('aria-labelledby', sectionTitle.id);
                                        } else {
                                            widgetLayout.setAttribute('role', 'region');
                                            widgetLayout.setAttribute('aria-label', tagData.wsc_widget_title || 'Stories carousel');
                                        }
                                    }

                                    setTimeout(() => setupScrollArrows(containerId), 200);
                                }
                            },
                            [BlazeSDK.Delegations.onWidgetError]: () => container.style.display = 'none'
                        }
                    });
                } catch {
                    container.style.display = 'none';
                }
            });

            // Process highlight containers
            document.querySelectorAll('.match-highlight-container').forEach(container => {
                const { matchId, teams = '', label = '' } = container.dataset;
                if (!matchId) return;

                const observer = new MutationObserver(mutations => {
                    mutations.forEach(mutation => {
                        mutation.addedNodes.forEach(node => {
                            if (node.tagName?.toLowerCase() === 'blaze-widget-layout') {
                                const styles = {
                                    border: 'none',
                                    borderWidth: '0',
                                    borderColor: 'transparent',
                                    background: 'transparent'
                                };
                                Object.assign(node.style, {
                                    ...styles,
                                    opacity: '0',
                                    position: 'absolute',
                                    pointerEvents: 'auto'
                                });
                                node.querySelectorAll('blaze-div, blaze-image').forEach(el =>
                                    Object.assign(el.style, styles));
                            }
                        });
                    });
                });

                observer.observe(container, { childList: true, subtree: true });

                try {
                    BlazeSDK.WidgetGridView(container.id, {
                        ...commonWidgetConfig,
                        labels: BlazeSDK.LabelBuilder().singleLabel(label),
                        theme: matchHighlightTheme,
                        shouldOrderWidgetByReadStatus: true,
                        delegates: {
                            [BlazeSDK.Delegations.onWidgetDataLoadCompleted]: e => {
                                if (e.detail.contentCount === 0) {
                                    BlazeSDK.WidgetGridView(container.id, {
                                        ...commonWidgetConfig,
                                        labels: BlazeSDK.LabelBuilder().singleLabel(teams),
                                        theme: matchHighlightTheme,
                                        shouldOrderWidgetByReadStatus: true
                                    });
                                }
                            },
                            [BlazeSDK.Delegations.onWidgetError]: () => container.style.display = 'none'
                        }
                    });
                } catch {
                    container.style.display = 'none';
                }
            });
        };

        // Listen for the BlazeSDK connection event
        document.addEventListener('onBlazeSDKConnect', () => {
            clearTimeout(connectionTimeout);
            processWidgets();
        });

        // Fallback: Check if we're in WordPress admin and try alternative approach
        const isWordPressAdmin = window.location.href.includes('/wp-admin/') || 
                               document.body.classList.contains('wp-admin') ||
                               document.querySelector('#wpadminbar');
        
        if (isWordPressAdmin) {
            // Try to process widgets after a short delay
            connectionTimeout = setTimeout(() => {
                if (!fallbackAttempted) {
                    fallbackAttempted = true;
                    processWidgets();
                }
            }, 2000);
            
            // Also try when the page is fully loaded
            window.addEventListener('load', () => {
                setTimeout(() => {
                    if (!fallbackAttempted) {
                        fallbackAttempted = true;
                        processWidgets();
                    }
                }, 1000);
            });
        } else {
            // For non-admin pages, set a longer timeout as fallback
            connectionTimeout = setTimeout(() => {
                if (!fallbackAttempted) {
                    fallbackAttempted = true;
                    processWidgets();
                }
            }, 5000);
        }
    }

    function initializeWhenReady() {
        if (window.__SP_BLAZE_STORIES_READY__) {
            return;
        }
        if (typeof BlazeSDK === 'undefined' || typeof window.blazeStoriesData === 'undefined') {
            if (window._blazeInitRetryCount === undefined) window._blazeInitRetryCount = 0;
            if (window._blazeInitRetryCount < BLAZE_INIT_RETRY_MAX) {
                window._blazeInitRetryCount++;
                setTimeout(initializeWhenReady, BLAZE_SDK_RETRY_MS);
            }
            return;
        }
        initializeBlazeStories();
    }

    function resetBlazeInitRetriesAndStart() {
        if (window.__SP_BLAZE_STORIES_READY__) {
            return;
        }
        window._blazeSdkRetryCount = 0;
        window._blazeInitRetryCount = 0;
        initializeWhenReady();
    }

    document.addEventListener('OneTrustGroupsUpdated', resetBlazeInitRetriesAndStart);
    document.addEventListener('SPOptanonWrapperCalled', resetBlazeInitRetriesAndStart);
    document.addEventListener('SPConsentFanSdkLoaded', resetBlazeInitRetriesAndStart);
    window.addEventListener('load', resetBlazeInitRetriesAndStart);

    initializeWhenReady();
	});
